import {
  ExpertCard,
  HomeAgentCardStyle,
  HomeAgentIconAsset,
  HomeCompanyProfileSection,
  HomeConnectionDefinition,
  HomeQuickActionPrompt,
} from './home.models';

export const HOME_LOADER_MIN_MS = 500;
export const HOME_ROLE_USUARIO_ID = 3;

export const HOME_DEFAULT_EXPERT_CARDS: ExpertCard[] = [
  { iconPath: 'assets/images/support.svg', iconBg: '#E0E7FF', tags: ['DIRECCION'], title: 'Agente Dirección / CEO', shortTitle: 'CEO', description: 'Acompañamiento estratégico para entender el estado real del negocio, alinear objetivos y tomar decisiones clave con una visión global y actualizada.', features: ['Visión estratégica integral', 'Toma de decisiones crítica', 'Reportes de alto nivel'], defaultPrompt: '¿Cuál es el estado actual del negocio?' },
  { iconPath: 'assets/images/bank.svg', iconBg: '#EEF2FF', tags: ['FISCAL'], title: 'Agente Financiero / Fiscal', shortTitle: 'Finanzas', description: 'Supervisión continua de la información financiera y fiscal para controlar resultados, anticipar desviaciones y tomar decisiones con total seguridad.', features: ['Análisis de balances', 'Proyecciones de flujo', 'Control de gastos'], defaultPrompt: '¿Cómo están los resultados financieros?' },
  { iconPath: 'assets/images/finance.svg', iconBg: '#F0FDF4', tags: ['VENTAS'], title: 'Agente Ventas / Clientes', shortTitle: 'Ventas', description: 'Análisis y seguimiento del proceso comercial, clientes y oportunidades para detectar mejoras, optimizar el pipeline y aumentar las ventas.', features: ['Embudo de conversión', 'Rendimiento comercial', 'Previsión de cierre'], defaultPrompt: '¿Cómo está el proceso comercial?' },
  { iconPath: 'assets/images/mechanic.svg', iconBg: '#FFF7ED', tags: ['RRHH'], title: 'Agente RRHH / Operaciones', shortTitle: 'RRHH', description: 'Gestión integral de personas, operaciones y recursos para mejorar la organización interna, optimizar tiempos y aumentar la eficiencia.', features: ['Gestión de talento', 'Clima organizacional', 'Búsqueda y selección'], defaultPrompt: '¿Cómo está la operación?' },
  { iconPath: 'assets/images/group.svg', iconBg: '#FEF3C7', tags: ['MARKETING'], title: 'Agente Marketing / Mercado', shortTitle: 'Marketing', description: 'Evaluación constante del mercado, la competencia y las campañas para identificar oportunidades de crecimiento y mejorar el posicionamiento.', features: ['Campañas digitales', 'Presencia de marca', 'Análisis de ROI'], defaultPrompt: '¿Cómo está el mercado y la competencia?' },
];

export const HOME_QUICK_ACTION_PROMPTS: HomeQuickActionPrompt[] = [
  { prompt: '¿Cuál es el estado actual del negocio?', expert: 'Agente Dirección / CEO' },
  { prompt: '¿Qué decisiones estratégicas debería priorizar?', expert: 'Agente Dirección / CEO' },
  { prompt: '¿Cuáles son los principales riesgos del negocio?', expert: 'Agente Dirección / CEO' },
  { prompt: '¿Cómo puedo mejorar la rentabilidad?', expert: 'Agente Dirección / CEO' },
  { prompt: '¿Qué oportunidades de crecimiento tenemos?', expert: 'Agente Dirección / CEO' },
  { prompt: '¿Cómo están los resultados financieros?', expert: 'Agente Financiero / Fiscal' },
  { prompt: '¿Cómo está el proceso comercial?', expert: 'Agente Ventas / Clientes' },
  { prompt: '¿Cómo está la operación?', expert: 'Agente RRHH / Operaciones' },
  { prompt: '¿Cómo está el mercado y la competencia?', expert: 'Agente Marketing / Mercado' },
];

export const HOME_MOTIVATIONAL_PHRASES: string[] = [
  'El éxito es la suma de pequeños esfuerzos repetidos cada día.',
  'La constancia es la clave del éxito.',
  'Hoy es un buen día para empezar algo grande.',
  'Cree en ti y todo será posible.',
  'El único límite es tu imaginación.',
  'Hazlo con pasión o no lo hagas.',
  'Cada día cuenta para alcanzar tus metas.',
  'El futuro pertenece a quienes creen en la belleza de sus sueños.',
];

export const HOME_ALL_CONNECTIONS: HomeConnectionDefinition[] = [
  { id: 'mirai', name: 'Mirai ERP', status: 'available' },
  { id: 'a3erp', name: 'A3ERP', status: 'available' },
  { id: 'odoo_mcp', name: 'Odoo (MCP)', status: 'available' },
  { id: 'sap', name: 'SAP Business One', status: 'coming_soon' },
  { id: 'tecfito', name: 'Tecfito', status: 'coming_soon' },
  { id: 'a3innuva_erp', name: 'a3innuva ERP', status: 'coming_soon' },
  { id: 'hubspot', name: 'HubSpot', status: 'coming_soon' },
  { id: 'teams', name: 'Teams', status: 'coming_soon' },
  { id: 'outlook', name: 'Outlook', status: 'available' },
  { id: 'calendar', name: 'Calendar', status: 'available' },
  { id: 'sharepoint', name: 'SharePoint', status: 'available' },
  { id: 'hrlog', name: 'HRLOG', status: 'coming_soon' },
  { id: 'a3innuva', name: 'a3innuva', status: 'coming_soon' },
  { id: 'wordpress', name: 'Wordpress', status: 'coming_soon' },
  { id: 'prestashop', name: 'Prestashop', status: 'coming_soon' },
  { id: 'shopify', name: 'Shopify', status: 'coming_soon' },
  { id: 'google_ads', name: 'Google Ads', status: 'coming_soon' },
  { id: 'looker_studio', name: 'Looker Studio', status: 'coming_soon' },
  { id: 'boe', name: 'BOE', status: 'coming_soon' },
  { id: 'hacienda', name: 'Hacienda AEAT', status: 'coming_soon' },
  { id: 'seguridad_social', name: 'Seguridad Social', status: 'coming_soon' },
  { id: 'notifica_app', name: 'Notifica APP', status: 'coming_soon' },
  { id: 'agricultura', name: 'Ministerio de Agricultura', status: 'coming_soon' },
  { id: 'informa_db', name: 'INFORMA D&B', status: 'coming_soon' },
  { id: 'fandit', name: 'FANDIT', status: 'coming_soon' },
];

export const HOME_AGENT_ICON_SVG_MAP: Record<string, HomeAgentIconAsset> = {
  briefcase: { path: 'assets/images/support.svg', bg: '#FCE7EF' },
  coins: { path: 'assets/images/bank.svg', bg: '#EEF2FF' },
  'chart-line': { path: 'assets/images/finance.svg', bg: '#F0FDF4' },
  cogs: { path: 'assets/images/mechanic.svg', bg: '#FFF7ED' },
  bullhorn: { path: 'assets/images/group.svg', bg: '#FEF3C7' },
};

export const HOME_COMPANY_PROFILE_SECTIONS: HomeCompanyProfileSection[] = [
  { weight: 20, fields: ['name', 'commercial_name', 'address', 'postal_code', 'city', 'province', 'phone', 'mobile_phone', 'website', 'email'] },
  { weight: 15, fields: ['cnae', 'company_size', 'num_employees', 'foundation_date', 'legal_form'] },
  { weight: 10, fields: ['sales_2021', 'sales_2022', 'sales_2023', 'sales_2024', 'sales_2025'] },
  { weight: 15, fields: ['revenue_target', 'margin_target', 'ebitda_target', 'arr', 'productivity_target', 'customer_satisfaction'] },
  { weight: 15, fields: ['mission', 'vision', 'core_values'] },
  { weight: 10, fields: ['value_description', 'target_market'] },
  { weight: 5, fields: ['linkedin_url', 'instagram_url', 'facebook_url', 'google_business_url'] },
  { weight: 10, fields: ['competitor_1_nif', 'competitor_1_name', 'competitor_1_web', 'competitor_2_nif', 'competitor_2_name', 'competitor_2_web', 'competitor_3_nif', 'competitor_3_name', 'competitor_3_web'] },
];

export const HOME_FIELD_ALIASES: Record<string, string[]> = {
  mobile_phone: ['mobile'],
  foundation_date: ['constitution_date', 'billing_start_date'],
  revenue_target: ['annual_income'],
  margin_target: ['profit_margin'],
  ebitda_target: ['ebitda'],
  productivity_target: ['productivity_per_employee'],
  customer_satisfaction: [],
  core_values: ['values'],
  linkedin_url: ['linkedin'],
  instagram_url: ['instagram'],
  facebook_url: ['facebook'],
  google_business_url: ['google_business'],
};

export const HOME_CONNECTION_LOGOS: Record<string, string> = {
  a3erp: '/assets/images/A3ERP.svg',
  odoo_mcp: '/assets/images/Odoo.svg',
  mirai: '/assets/images/Mirai.png',
  outlook: '/assets/images/Outlook.svg',
  calendar: '/assets/images/Outlook Calendar.svg',
  sharepoint: '/assets/images/Sharepoint.svg',
};

export const HOME_EXPERT_TO_AGENT_NAME_MAP: Record<string, string> = {
  'Agente Dirección / CEO': 'Agente Dirección / CEO',
  'Agente Financiero / Fiscal': 'Agente Financiero / Fiscal',
  'Agente Ventas / Clientes': 'Agente Ventas / Clientes',
  'Agente RRHH / Operaciones': 'Agente RRHH / Operaciones',
  'Agente Marketing / Mercado': 'Agente Marketing / Mercado',
};

export const HOME_AGENT_CARD_STYLES: HomeAgentCardStyle[] = [
  { pattern: /dirección|direccion|ceo|director/i, iconPath: 'assets/images/support.svg', iconBg: '#E0E7FF', shortTitle: 'CEO', features: ['Visión estratégica integral', 'Toma de decisiones crítica', 'Reportes de alto nivel'] },
  { pattern: /financiero|fiscal|contab/i, iconPath: 'assets/images/bank.svg', iconBg: '#EEF2FF', shortTitle: 'Finanzas', features: ['Análisis de balances', 'Proyecciones de flujo', 'Control de gastos'] },
  { pattern: /ventas|clientes|comercial|sales/i, iconPath: 'assets/images/finance.svg', iconBg: '#F0FDF4', shortTitle: 'Ventas', features: ['Embudo de conversión', 'Rendimiento comercial', 'Previsión de cierre'] },
  { pattern: /rrhh|operaciones|recursos humanos/i, iconPath: 'assets/images/mechanic.svg', iconBg: '#FFF7ED', shortTitle: 'RRHH', features: ['Gestión de talento', 'Clima organizacional', 'Búsqueda y selección'] },
  { pattern: /marketing|mercado|publicidad/i, iconPath: 'assets/images/group.svg', iconBg: '#FEF3C7', shortTitle: 'Marketing', features: ['Campañas digitales', 'Presencia de marca', 'Análisis de ROI'] },
];
